import { chakra, useMultiStyleConfig } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import type { PropsWithChildren } from 'react';

import { usePartContext } from './util/index';

export type PartThumbnailContainerProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const PartThumbnailContainer = ({
  children,
  ...props
}: PartThumbnailContainerProps) => {
  const { size, variant } = usePartContext();
  const styles = useMultiStyleConfig('Part', { size, variant });

  return (
    <chakra.div __css={styles.thumbnailContainer} {...props}>
      {children}
    </chakra.div>
  );
};
